import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, Outlet, useNavigate } from 'react-router-dom';

import {
  adminSessionSelector,
  getAdminSession,
  isLoadingAdminSessionSelector,
} from 'src/store/adminAuth';

import { PageLoader } from 'src/components';
import { ROUTE } from 'src/constants';

export const ProtectedAdminRoute = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const adminSession = useSelector(adminSessionSelector);
  const isLoading = useSelector(isLoadingAdminSessionSelector);

  const savedSession = localStorage.getItem('admin-session');

  useEffect(() => {
    if (adminSession === false) {
      dispatch(getAdminSession({ navigate }));
    }
  }, [dispatch, navigate, adminSession]);

  return isLoading ? (
    <PageLoader />
  ) : savedSession ? (
    <Outlet />
  ) : (
    <Navigate to={ROUTE.ADMIN.LOGIN.MAIN} />
  );
};
